module.exports = __webpack_public_path__ + "media/images/plumber-bg-7561a6cbe5a43db34b56ed92ce0b50f5.jpg";